import React from "react";
import { Auth } from "aws-amplify";
import config from "../../aws-exports";

/* console.log(
  "OAuth Config - Domain:",
  process.env.REACT_APP_AMTPL_SSO_DOMAIN || config.oauth?.domain
); */
/* console.log("OAuth Config - RedirectSignIn:", window.location.origin + "/"); */
/* console.log("OAuth Config - ClientId:", config.aws_user_pools_web_client_id); */

const roleGroupMap = {
  agropreneur: "AMTPL_AGROPRENEURS",
  "global-partner": "AMTPL_GLOBAL_PARTNERS",
  "finance-partner": "AMTPL_FINANCE_PARTNERS",
  "seller-farmer": "AMTPL_SELLERS_AND_FARMERS",
  buyer: "AMTPL_BUYERS",
  amtpl: "AMTPL_ADMINS",
};

const LoginAuto = ({ role: propRole }) => {
  // Extract role and loginType from URL query parameters
  const searchParams = new URLSearchParams(window.location.search);
  const urlRole = searchParams.get("role");
  const loginType = searchParams.get("loginType") || "google"; // Default to google
  const role = urlRole || propRole || "global-partner";

  console.log(" Login component initialized with role:", role);
  console.log(" URL role parameter:", urlRole);
  console.log(" Login type:", loginType);
  console.log(" Expected group for this role:", roleGroupMap[role]);

  const googleLogin = async () => {
    try {
      /* console.log("Initiating Google OAuth login for role:", role); */
      localStorage.setItem("pendingOAuthRole", role);
      /* console.log("Stored role in localStorage:", role); */
      Auth.configure({
        oauth: {
          domain:
            process.env.REACT_APP_AMTPL_SSO_DOMAIN ||
            config.oauth?.domain ||
            "auth-devlab.grainsglobaldev.com",
          scope: [
            "email",
            "phone",
            "openid",
            "aws.cognito.signin.user.admin",
            "profile",
          ],
          redirectSignIn: window.location.origin + "/",
          redirectSignOut: window.location.origin + "/",
          responseType: "code",
        },
      });
      /* console.log(
        "OAuth configured with domain:",
        process.env.REACT_APP_AMTPL_SSO_DOMAIN || config.oauth?.domain
      ); */
      /* console.log("OAuth redirectSignIn:", window.location.origin + "/"); */
      const oauthDomain =
        process.env.REACT_APP_AMTPL_SSO_DOMAIN ||
        config.oauth?.domain ||
        "auth-devlab.grainsglobaldev.com";
      const clientId = config.aws_user_pools_web_client_id;
      const redirectUri = encodeURIComponent(window.location.origin + "/");
      const scope = encodeURIComponent(
        "email phone openid aws.cognito.signin.user.admin profile"
      );
      const state = encodeURIComponent(JSON.stringify({ role }));
      const googleAuthUrl =
        `https://${oauthDomain}/oauth2/authorize?` +
        `identity_provider=Google&` +
        `redirect_uri=${redirectUri}&` +
        `response_type=code&` +
        `client_id=${clientId}&` +
        `scope=${scope}&` +
        `state=${state}&` +
        `prompt=select_account`;
      /* console.log("Redirecting to Google OAuth with prompt=select_account"); */
      window.location.href = googleAuthUrl;
    } catch (error) {
      console.error("Google login error:", error);
      localStorage.removeItem("pendingOAuthRole");
    }
  };

  const linkedinLogin = async () => {
    try {
      /* console.log("Initiating LinkedIn OAuth login for role:", role); */
      localStorage.setItem("pendingOAuthRole", role);
      /* console.log("Stored role in localStorage:", role); */

      // LinkedIn through Cognito OIDC only supports: openid, profile, email
      // Don't include phone or aws.cognito.signin.user.admin for LinkedIn
      const oauthDomain =
        process.env.REACT_APP_AMTPL_SSO_DOMAIN ||
        config.oauth?.domain ||
        "auth-devlab.grainsglobaldev.com";
      const clientId = config.aws_user_pools_web_client_id;
      const redirectUri = encodeURIComponent(window.location.origin + "/");

      // Use only LinkedIn-compatible scopes
      const scope = encodeURIComponent("openid profile email");
      const state = encodeURIComponent(JSON.stringify({ role }));

      const linkedinAuthUrl =
        `https://${oauthDomain}/oauth2/authorize?` +
        `identity_provider=LinkedIn&` +
        `redirect_uri=${redirectUri}&` +
        `response_type=code&` +
        `client_id=${clientId}&` +
        `scope=${scope}&` +
        `state=${state}`;

      /* console.log("Redirecting to LinkedIn OAuth"); */
      console.log("LinkedIn Auth URL:", linkedinAuthUrl);
      window.location.href = linkedinAuthUrl;
    } catch (error) {
      console.error("LinkedIn login error:", error);
      localStorage.removeItem("pendingOAuthRole");
    }
  };

  // Execute login based on loginType parameter
  if (loginType === "linkedin") {
    linkedinLogin();
  } else {
    // Default to Google
    googleLogin();
  }

  return <div className="main-login-page"></div>;
};

export default LoginAuto;
